<template>
    <div>
                    <div v-for="(job, index) in jobsList" :key="index" >
                    <div class="card mr-3 ml-3 mb-3">
                        <div class="p-2 d-flex">
                        <div class="col-2 mr-2 mr-lg-0 mr-md-0">
                            <div class="backgroundcolor1 p-lg-2 borderradius10 mr-2 mt-4 text-center">
                            <img src="../../assets/Profile_placehlder.svg" class="prof-img rounded-circle" alt="companylogo">
                            </div>
                        </div>
                        <div class="col-10 pl-0 pt-3">
                            <div class="d-flex justify-content-between">
                            <div>
                                <span class="fontsize24 black proximanova stylebold mt-lg-2 pointer" @click="viewJobDetails(job)">{{job.jobTitle}}</span>
                            </div>
                            <div  class="row">
                                <span class="fontsizemd black stylebold proximanova mr-3 pointer d-none d-md-block" @click="viewJobDetails(job)">View Details</span>
                                <img src="../../assets/horizontal_menu_icon.svg" width="20px" height="20px" v-popover = "{name: job.moremenu}"  class="mr-4 pointer more_optionhoriz" alt="moremenu">
                                <popover v-bind:name="job.moremenu"  class="postvideomenu" id="jobmenu">
                                        <div class="p-1">                                        
                                            <div class="d-flex p-1 pl-2 ml-1 action" >
                                            <img src="../../assets/Editvideo.svg" alt="edit" class="img-fluid">
                                            <span class="p-2 font14-opacity80 proximanova">Edit</span>
                                            </div>
                                            <div class="d-flex p-1 pl-2 ml-1 action" >
                                            <img src="../../assets/Deletevideo.svg" alt="delete" class="img-fluid">
                                            <span class="p-2 font14-opacity80 proximanova">Delete</span>
                                            </div>
                                        </div>
                                        </popover>
                            </div>
                            </div>
                            <div class="d-flex flex-column mt-1">
                            <span class="fontsize16 black proximanova">{{job.companyName}}</span>
                            <div>
                                <span class="fontsizemd black60 proximanova">{{job.type}}</span>
                                <span class="ml-2 mr-2 black60">|</span>
                                <span class="fontsizemd black60 proximanova">{{job.country}}</span>
                            </div>
                            </div>
                            <div class="d-flex mt-2 justify-content-between">
                            <div class="mt-1">
                                <span class="fontsizemd black stylebold proximanova">1d ago</span>
                                <span class="ml-2 mr-2 black60"> - </span>
                                <span class="fontsizemd black60 proximanova">Hiring Within 7 days</span>
                            </div>
                            </div>
                            <div class="d-flex pt-2 pb-2 justify-content-between">
                            <div class="pt-1">
                                <a  class="btn button-create btn-color mr-2 "  id="search">
                                                    <span class="fontsize14 proximanova">Save</span>
                                                </a>
                                                <a  class="btn button-create sign-in-button"  id="search">
                                                    <span class="fontsize14 white proximanova">Re-Post</span>
                                                </a>
                            </div>
                            </div>
                        </div>
                        </div>                   
                    </div>
                    </div>
                </div>
</template>
<script>
import Vue from "vue";
import Popover from "vue-js-popover";
import httpbusiness from "@/js/http-business.js"
import router from '../../router.js'
import { bus } from "@/main.js";
Vue.use(Popover);
export default{
    components:{
    },
    data(){
        return{
            pageloader: false,
            jobStatus : 'active',
            jobsList : [
              {companyName : 'WorkNotion', type:'Professional Network services', country : 'USA', jobTitle : 'Product Designer', jobStatus:'active',moremenu: 'popover'+0},
              {companyName : 'WorkNotion', type:'Professional Network services', country : 'USA', jobTitle : 'Frontend Developer', jobStatus:'inactive',moremenu: 'popover'+1},
              {companyName : 'WorkNotion', type:'Professional Network services', country : 'USA', jobTitle : 'Java Developer', jobStatus:'inactive',moremenu: 'popover'+2}
            ],
            showCreatedJobsTab: true,
            showpostedJobsTab:false
        }
    },
    created (){
        
    },
    methods:{
      viewJobDetails(job) {
        console.log(job)
        router.push({
          name : 'viewjob', params: { id: job.jobId}
        })
      },
      
    },
    mounted() {
      window.scrollTo(0, 0)
    }
}
</script>
<style scoped>
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.jobsection{
  overflow-x: auto;
}
.dot{
  height: 5px;
  width: 5px;
  border-radius: 50%;
  background-color: tomato;
}
select > option{
  background-color: white;
  color: black;
}
.btn-color{
  border-color: #1F1F1F;
}
.btn{
    width: 80px;
}
.card-header1 {
  border: 1px solid #d9dce1;
  opacity: 1;
  border-radius: 8px;
}  
 .dropdown-position-bottom.postvideomenu {
    z-index: 3 !important;
    color: rgba(31,31,31,1)  !important;
    font-size: 12px !important;
    top: 50px !important;
    font-weight: 500;
    width: 140px !important;
    left: unset !important;
  }
  .vue-popover.dropdown-position-bottom.postvideomenu:before {
    display: none !important;
  }
@media only screen and (max-width: 600px) {
  .pageloader {
    width: 20%;
    margin-top: 25%;
    margin-left: 40%;
  }
  .fontsize24{
    font-size: 16px
  }
   .prof-img {
    width: 36px;
    height: 36px;
}
  
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}
</style>
